import { createContext, useContext, useState, useEffect } from "react";
import { getDoc, collect, doc } from "firebase/firestore";
import { db } from "../firebase";

export const AboutContext = createContext();
export const useAbout = ()=>{
    return useContext(AboutContext)
}

export const AboutProvider = ({children})=>{
    const [state, setState] = useState()
    const getData = async()=>{
        const qu1 = doc(db, "introField", "intro")
        const qu2 = doc(db, "about", "about1")
        const qu3 = doc(db, "skillset", "skills")
        const res1 = await getDoc(qu1);
        const res2 = await getDoc(qu2);
        const res3 = await getDoc(qu3);
        setState([res1.data().intro, res2.data().about1, res3 && res3.data().skills.split("@")])
        
    }
    useEffect(()=>{
      getData()
    }, [])


    return <AboutContext.Provider value={state}>
        { children }
    </AboutContext.Provider>
}